module.exports = __webpack_public_path__ + "img/vertical-red-line-long.7ee76eba.svg";